import { combineReducers } from 'redux'
import { parametries, inconsistencies } from './reducers'
import { getDynamicParametries, getInconsistencies } from './actions'

export { getDynamicParametries, getInconsistencies }

export default combineReducers({ parametries, inconsistencies })
